import {create} from "zustand";
import {persist} from "zustand/middleware";

const useUserMaskStore = create(
    persist(
        (set, get) => ({
            maskedCompany: null,

            addMaskedCompany: (company) => {
                set({maskedCompany: company});
            },

            returnBook: (id) => {
                set((state) => {
                    if (!state.maskedCompany || !state.maskedCompany.books) return state;

                    const updatedCompany = {
                        ...state.maskedCompany,
                        books: state.maskedCompany.books.map((book) =>
                            book.id === id ? {...book, status: "available"} : book
                        ),
                    };

                    return {maskedCompany: updatedCompany};
                });
            },

            clearMaskedCompany: () => {
                set({maskedCompany: null});
            },

            reset: () => {
                set({maskedCompany: null});
            },
        }),
        {
            name: "user-mask",
            getStorage: () => sessionStorage,
        }
    )
);

export default useUserMaskStore;
